const state = {
  isAddingEvent: false,
  showDetails: false,
  showMulti: false,
};

const mutations = {
  setIsAddingEvent(state, isAdding) {
    state.isAddingEvent = isAdding;
  },
  setShowDetails(state, visible) {
    state.showDetails = visible;
  },
  setShowMulti(state, visible) {
    state.showMulti = visible;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
